import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CapicheLoggerService } from 'capiche-logger';
import { CapicheMaterialModule } from 'capiche-material';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-forgot-password',
  imports: [CommonModule, CapicheMaterialModule, FormsModule, ReactiveFormsModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css',
})
export class ForgotPasswordComponent {
  logger = new CapicheLoggerService('forgot-password.component:', false);
  message: string = '';
  emailControl = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, Validators.email],
  });
  formSubmitted = false;
  success: boolean | undefined = undefined;

  constructor(private authService: AuthService) {
    this.logger.log('constructor');
  }

  async onSubmit() {
    this.formSubmitted = true;
    if (this.emailControl.valid) {
      try {
        await this.authService.forgotPassword(this.emailControl.value);
        this.message = "We've sent you a password reset email, please check your inbox (and your junk folder).";
        this.success = true;
      } catch (e: any) {
        this.logger.error('Error sending password reset email:', e);
        this.message = e.message || 'An error occurred. Please try again.';
        this.success = false;
      }
    } else {
      this.message = 'Please correct the errors before submitting.';
    }
  }

  onFocus() {

    this.formSubmitted = false;
    this.emailControl.markAsUntouched();
    this.message = '';
  }
}
